import { useQuery } from "@tanstack/react-query";
import {
  getFactoryCreditBalance,
  CreditBalance,
  getFactoryCodCreditInfo,
  CodCreditInfo,
  getActiveCreditLots,
  ActiveCreditLotsResponse,
} from "services/factoryCreditApi";

export const CREDIT_BALANCE_QUERY_KEY = "factoryCreditBalance";
export const COD_CREDIT_INFO_QUERY_KEY = "factoryCodCreditInfo";
export const ACTIVE_CREDIT_LOTS_QUERY_KEY = "factoryActiveCreditLots";

export const useFactoryCreditBalance = () =>
  useQuery<CreditBalance, Error>({
    queryKey: [CREDIT_BALANCE_QUERY_KEY],
    queryFn: getFactoryCreditBalance,
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnMount: "always",
  });

/**
 * วงเงินเครดิต COD + ต้นทุนของออเดอร์ที่จะรับ — ใช้แสดงผลก่อน accept (ModalOrderDetail เดี่ยว
 * ส่ง orderId, BulkAcceptNewOrdersModal ส่ง orderIds)
 */
export const useFactoryCodCreditInfo = (
  params?: { orderId?: string; orderIds?: string[] },
  options?: { enabled?: boolean }
) =>
  useQuery<CodCreditInfo, Error>({
    queryKey: [COD_CREDIT_INFO_QUERY_KEY, params?.orderId ?? null, params?.orderIds ?? null],
    queryFn: () => getFactoryCodCreditInfo(params),
    enabled: options?.enabled ?? true,
    staleTime: 10_000,
    refetchOnMount: "always",
  });

/**
 * ทุก lot ที่ยัง active เรียงใกล้หมดอายุสุดก่อน — ใช้กับ modal รายละเอียด "เครดิตกำลังหมดอายุ"
 * โหลดแบบ lazy เท่านั้น (enabled=false ปกติ, true ตอน modal เปิด) ไม่ต้องโหลดทุกครั้งที่การ์ดแสดง
 */
export const useActiveCreditLots = (enabled: boolean) =>
  useQuery<ActiveCreditLotsResponse, Error>({
    queryKey: [ACTIVE_CREDIT_LOTS_QUERY_KEY],
    queryFn: getActiveCreditLots,
    enabled,
    staleTime: 10_000,
  });
